<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <h4 class="title" :style="{'font-size': '20px','font-weight':'600'}">
            {{$I18n("use_balance")}}
          </h4>
          <h4 :style="{'margin-top': '6px','margin-bottom': '12px','font-size':'44px','font-weight':'600'}">
            {{money == 0 ?"0" :`${money_type == 1 ?"$" :"¥"}${money}` }}
          </h4>
        </md-card-header>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片头 -->
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>{{icon}}</md-icon>
          </div>

          <h4 class="title">
            {{title}} 
          </h4>
        </md-card-header>
        <!-- 卡片主体(表单) -->
        <div class="md-layout card-form">
          <div class="md-layout md-layout-item md-size-65">
            <!-- 类型 -->
            <div class="md-layout-item md-size-30 left-layout-item">
              <md-field>
                <label>{{$I18n("type")}}</label>
                <md-select  v-model="searchForm.type" >
                  <md-option :value="0">{{$I18n("all")}}</md-option>
                  <md-option :value="1">{{$I18n("recharge")}}</md-option>
                  <md-option :value="2">{{$I18n("consume")}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 创建时间 (date) -->
            <div class="md-layout-item md-size-70 left-layout-item">
              <md-field class="md-theme-default md-has-value">
                <!-- <label>{{$I18n("create_time")}}</label> -->
                <el-date-picker
                  class="md-date-form-item"
                  align="left"
                  v-model="searchForm.time"
                  type="daterange"
                  prefixIcon="no"
                  range-separator="~"
                  value-format="yyyy-MM-dd HH:mm:SS"
                  :picker-options="pickerOptions"
                  :start-placeholder="$I18n('start')"
                  :end-placeholder="$I18n('end')">
                </el-date-picker>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-layout-item md-size-35">
            <div class="md-layout-item md-size-25">
              <md-button class= "left-icon md-info" @click="form_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </div>
        <!-- 卡片主体(表格) -->
        <md-card-content>
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('flow_id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('trading_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('currency_type')">{{ item.money_type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('money')">{{ item.money }}</md-table-cell>
              <md-table-cell :md-label="$I18n('pay_id')">{{ item.pay_order_id === "0" ?"-" :item.pay_order_id}}</md-table-cell>
              <!-- <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button
                  @click.stop
                  @click="more_info(item)"
                  class="md-info left-icon"
                  :style="{
                    'width': 'unset',
                    'height': 'unset',
                    'line-height':'16px'
                  }"
                  >{{$I18n("more_info")}}</md-button
                >
              </md-table-cell> -->
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <md-card-actions v-if="total > 0" md-alignment="space-between">
          <div class="">
            <p class="card-category">
              {{$I18n("total" )}} : {{total}}
            </p>
          </div>
          <pagination
            class="pagination-no-border"
            type= "info"
            v-model="currentPage"
            :per-page="pageSize"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import { Pagination } from "@/components";
// import { Modal } from '@/components';
import { timestampToString } from "@/common/tools.js";
export default {
  components: {
    Pagination,
    // Modal,
  },
  data() {
    return {
      money:0,
      money_type:0,

      title : this.$I18n("bills"),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      searchForm : {
        type : 0,
        time:["",""],
      },
      searchData : {
        type : 0,
        time:["",""],
      },
      // 表格相关
      icon  : "payment",
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,

      // // 弹窗相关
      // openModal: false,  // 是否打开弹窗
      // openModalType : "upload", // 弹窗类型
      // modalTitle : "",  // 弹窗标题
      // // 弹窗表单相关
      // modalData : {
      //   state : "1",
        // create_time:[nDaysAgo(7)+ " 00:00:00", nDaysAgo(0)+ " 00:00:00"],
      //   file : "",
      //   file_url : "",
      // },
      // // 弹窗表单报错相关
      // error: {
      //   file : false,
      // },
    };
  },
  mounted : function() {
    this.api_getPageData();
    this.api_getBalance();
  },
  watch: {
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          let type_name = "";
          switch(parseInt(item.type)){
            case 1: 
              type_name = this.$I18n("recharge");
              break;
            case 2: 
              type_name = this.$I18n("consume");
              break;
            default : 
              type_name = this.$I18n("unknow");
              break;
          }
          let money_type_name = "";
          switch(parseInt(item.money_type)){
            case 1: 
              money_type_name = this.$I18n("usd");
              break;
            case 2: 
              money_type_name = this.$I18n("cny");
              break;
            default : 
              money_type_name = this.$I18n("unknow");
              break;
          }
          return {
            type_name,
            money_type_name,
            create_time : timestampToString(item.gmt_create * 1000),
            ... item,
          }
        })
      }
    },
  },
  methods: {
    // 
    api_getBalance(){
      this.$api.getBalance({})
        .then(this.$Then(res => {
          this.money = res.data.money
          this.money_type = res.data.money_type
        }))
        .catch(this.$Catch())
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData(){
      this.searchData = {...this.searchForm}
      this.currentPage = 1;
      this.api_getPageData();
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      this.$api.getUserFlow({
          ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
          gmt_start: this.searchData.time && this.searchData.time[0] ? new Date(this.searchData.time[0]).getTime()/1000 :"",
          gmt_end: this.searchData.time && this.searchData.time[1] ? new Date(this.searchData.time[1]).getTime()/1000 :"",
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.openModal = false;
      this.error.file = false;
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .modal-date.md-date-form-item{
    width: 0;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
    text-align: left;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>
